import React from 'react';
import { useTranslation } from 'react-i18next';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogContentText, 
  DialogActions, 
  Button 
} from '@mui/material';

const ErrorModal = ({ 
  open, 
  onClose, 
  message 
}) => {
  const { t } = useTranslation();
  const isWorkflowStopped = message && message.includes("训练流程已停止退出");
  
  const handleRefresh = () => {
    window.location.reload();
  };
  
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="error-dialog-title"
      aria-describedby="error-dialog-description"
      PaperProps={{
        style: {
          backgroundColor: '#353535',  // 稍微亮一点的深灰
          color: '#e0e0e0',
          borderRadius: '8px',
          border: '1px solid #4a4a4a'
        }
      }}
    >
      <DialogTitle 
        id="error-dialog-title" 
        style={{ 
          color: isWorkflowStopped ? '#ff6b6b' : '#f0a500',  // 工作流停止错误用红色
          fontWeight: 'bold',
          borderBottom: '1px solid #4a4a4a'
        }}
      >
        {isWorkflowStopped ? '⚠️ ' + t('error_modal_workflow_stopped') : t('error_modal_title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText 
          id="error-dialog-description"
          style={{ 
            color: '#c0c0c0',  // 柔和的浅灰
            fontSize: '0.95rem',
            marginTop: '10px'
          }}
        >
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {isWorkflowStopped && (
          <Button 
            onClick={handleRefresh} 
            variant="contained"
            style={{ 
              backgroundColor: '#4caf50',
              color: '#ffffff',
              marginRight: '10px',
              marginBottom: '10px'
            }}
          >
            {t('error_modal_refresh')}
          </Button>
        )}
        <Button 
          onClick={onClose} 
          variant="outlined"
          style={{ 
            color: '#f0a500',  // 与标题相同的金黄色
            borderColor: '#4a4a4a',
            marginRight: '10px',
            marginBottom: '10px'
          }}
        >
          {isWorkflowStopped ? t('error_modal_refresh_later') : t('error_modal_ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorModal;